import { getNotificationSettings, saveNotificationSettings } from '../../../core/api/reclamations';
import * as toastMessages from '../../../core/toastMessages';

const CLAIM_NOTIFICATION_TIMING_HOUR_OPTIONS = [8, 16, 24, 48, 72];
const CLAIM_EMAIL_APPROVAL_NOTIFICATION_TYPE = 'claim_email_approval_needed';

export const getClaimNotificationTimingState = (settingsResponse) => {
  const rawSettings =
    settingsResponse?.results || settingsResponse?.notificationSettings || settingsResponse || [];
  const timingRecords = Array.isArray(rawSettings) ? rawSettings : rawSettings ? [rawSettings] : [];
  const relevantRecords = timingRecords.filter(
    (record) => record?.notificationType === CLAIM_EMAIL_APPROVAL_NOTIFICATION_TYPE
  );
  const globalRecord = relevantRecords.find((record) => record?.scope === 'global');
  const siteRecords = relevantRecords.filter((record) => record?.scope === 'site');
  const fallbackRecord = globalRecord || siteRecords[0] || {};
  const rawScope = globalRecord ? 'global' : 'site';
  const rawHours = Number(fallbackRecord.hoursDelay ?? fallbackRecord.hours ?? 72);
  const rawSiteIds = siteRecords.map((record) => record?.siteId).filter(Boolean);

  return {
    notificationTimingScope: rawScope === 'global' ? 'global' : 'site',
    notificationTimingHours: CLAIM_NOTIFICATION_TIMING_HOUR_OPTIONS.includes(rawHours)
      ? rawHours
      : 72,
    notificationTimingSiteIds: Array.isArray(rawSiteIds) ? rawSiteIds.map((id) => String(id)) : [],
    notificationTimingDirty: false,
  };
};

export const loadNotificationTimingSettings = async () => {
  try {
    const response = await getNotificationSettings();
    return getClaimNotificationTimingState(response);
  } catch (error) {
    toastMessages.apiError(error);
    return null;
  }
};

export const saveNotificationTimingSettings = async ({
  notificationTimingScope,
  notificationTimingHours,
  notificationTimingSiteIds,
}) => {
  const hoursDelay = Number(notificationTimingHours);
  if (!CLAIM_NOTIFICATION_TIMING_HOUR_OPTIONS.includes(hoursDelay)) {
    toastMessages.generateToastr('error', 'Invalid delay', 'Choose 8, 16, 24, 48, or 72 hours.');
    return false;
  }

  const siteIds =
    notificationTimingScope === 'site'
      ? notificationTimingSiteIds
          .map((id) => Number(id))
          .filter((id) => Number.isFinite(id) && id > 0)
      : [];

  if (notificationTimingScope === 'site' && siteIds.length === 0) {
    toastMessages.generateToastr(
      'error',
      'Select sites',
      'Select at least one site for per-site timing.'
    );
    return false;
  }

  const payload =
    notificationTimingScope === 'global'
      ? {
          notificationType: CLAIM_EMAIL_APPROVAL_NOTIFICATION_TYPE,
          scope: 'global',
          delayHours: hoursDelay,
        }
      : {
          notificationType: CLAIM_EMAIL_APPROVAL_NOTIFICATION_TYPE,
          scope: 'site',
          delayHours: hoursDelay,
          siteIds,
        };

  try {
    await saveNotificationSettings({ data: payload });
    return true;
  } catch (error) {
    toastMessages.apiError(error);
    return false;
  }
};
